import * as tslib_1 from "tslib";
import { Platform } from '@angular/cdk/platform';
import { OnDestroy, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { NetPromoterScoreModalService } from '@core/components/net-promoter-score-modal/net-promoter-score-modal.service';
import { BlatoutService } from '@core/services/blatout/blatout.service';
import { PushNotificationsService } from '@core/services/push-notifications/push-notifications.service';
import { SocketService } from '@core/services/socket.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { L10n, loadCldr } from '@syncfusion/ej2-base';
import * as caGregorian from 'cldr-data/main/pt/ca-gregorian.json';
import * as numbers from 'cldr-data/main/pt/numbers.json';
import * as timeZoneNames from 'cldr-data/main/pt/timeZoneNames.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import { registerLocale } from 'i18n-iso-countries';
import { Subject } from 'rxjs';
import { delay, filter, first, takeUntil } from 'rxjs/operators';
import iconNames from './icons.json';
loadCldr(numberingSystems, caGregorian, numbers, timeZoneNames);
var AppComponent = /** @class */ (function () {
    function AppComponent(document, fuseConfigService, translateService, platform, router, blatoutService, socketService, authenticationService, matDialog, pushNotificationsService, fuseSidebarService, matIconRegistry, domSanitizer, netPromoterScoreModalService) {
        var _this = this;
        this.document = document;
        this.fuseConfigService = fuseConfigService;
        this.translateService = translateService;
        this.platform = platform;
        this.router = router;
        this.blatoutService = blatoutService;
        this.socketService = socketService;
        this.authenticationService = authenticationService;
        this.matDialog = matDialog;
        this.pushNotificationsService = pushNotificationsService;
        this.fuseSidebarService = fuseSidebarService;
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.netPromoterScoreModalService = netPromoterScoreModalService;
        this.subscriptions = new Subject();
        this.loadIcons();
        this.router.events
            .pipe(filter(function (event) { return event instanceof NavigationStart || event instanceof NavigationEnd || event instanceof NavigationCancel; }))
            .subscribe(function (e) {
            var event = e;
        });
        var authenticatedNavigationStarted = this.router.events.pipe(takeUntil(this.subscriptions), filter(function (event) { return event instanceof NavigationStart; }), filter(function (event) {
            var url = event.url;
            var isLogin = url === '/login';
            var isRecoverPassword = url.includes('/login/recuperar-senha');
            return !isLogin && !isRecoverPassword;
        }));
        authenticatedNavigationStarted.subscribe(function () {
            _this.blatoutService.refresh();
        });
        var navigationStarted = this.router.events.pipe(takeUntil(this.subscriptions), filter(function (event) { return event instanceof NavigationStart; }));
        navigationStarted.subscribe(function () {
            _this.matDialog.closeAll();
            _this.fuseSidebarService.closeAll();
        });
        // Add languages
        this.translateService.addLangs(['es', 'en', 'pt']);
        registerLocale(require('i18n-iso-countries/langs/en.json'));
        registerLocale(require('i18n-iso-countries/langs/es.json'));
        registerLocale(require('i18n-iso-countries/langs/pt.json'));
        // Set the default language
        this.translateService.setDefaultLang('pt');
        // Use a language
        if (navigator.language.includes('en')) {
            this.translateService.use('en');
        }
        if (navigator.language.includes('pt')) {
            this.translateService.use('pt');
        }
        if (navigator.language.includes('es')) {
            this.translateService.use('es');
        }
        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix Start
         * ----------------------------------------------------------------------------------------------------
         */
        /**
         * If you are using a language other than the default one, i.e. Turkish in this case,
         * you may encounter an issue where some of the components are not actually being
         * translated when your app first initialized.
         *
         * This is related to ngxTranslate module and below there is a temporary fix while we
         * are moving the multi language implementation over to the Angular's core language
         * service.
         **/
        // Set the default language to 'en' and then back to 'tr'.
        // '.use' cannot be used here as ngxTranslate won't switch to a language that's already
        // been selected and there is no way to force it, so we overcome the issue by switching
        // the default language back and forth.
        /**
          setTimeout(() => {
            this._translateService.setDefaultLang('en');
            this._translateService.setDefaultLang('tr');
          });
        */
        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix End
         * ----------------------------------------------------------------------------------------------------
         */
        // Add is-mobile class to the body if the platform is mobile
        if (this.platform.ANDROID || this.platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }
        // Fix mobile browser viewport height
        window.addEventListener('resize', function () {
            var vh = window.innerHeight * 0.01;
            _this.document.documentElement.style.setProperty('--vh', vh + "px");
        });
        if (this.authenticationService.user) {
            this.socketService.reconnect();
            this.pushNotificationsService.refreshNotificationSubscription();
        }
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Subscribe to config changes
        this.fuseConfigService.config.pipe(takeUntil(this.subscriptions)).subscribe(function (config) {
            _this.fuseConfig = config;
            // Boxed
            if (_this.fuseConfig.layout.width === 'boxed') {
                _this.document.body.classList.add('boxed');
            }
            else {
                _this.document.body.classList.remove('boxed');
            }
            // Color theme - Use normal for loop for IE11 compatibility
            for (var i = 0; i < _this.document.body.classList.length; i++) {
                var className = _this.document.body.classList[i];
                if (className.startsWith('theme-')) {
                    _this.document.body.classList.remove(className);
                }
            }
            _this.document.body.classList.add(_this.fuseConfig.colorTheme);
        });
        L10n.load({
            pt: {
                daterangepicker: {
                    today: 'Hoje',
                    startLabel: 'Começa em',
                    endLabel: 'Termina em',
                    applyText: 'Confirmar',
                    cancelText: 'Cancelar',
                    selectedDays: 'Dias selecionados',
                    days: 'dias',
                    customRange: 'Intervalo customizado'
                }
            }
        });
        this.showNpsDialogAfterFirstLoggedNavigationEnds();
    };
    AppComponent.prototype.showNpsDialogAfterFirstLoggedNavigationEnds = function () {
        var _this = this;
        var afterFistNavigation$ = this.router.events.pipe(takeUntil(this.subscriptions), filter(function (event) { return event instanceof NavigationEnd; }), filter(function () { return _this.authenticationService.permissions.length > 0; }), first(), delay(1000));
        afterFistNavigation$.subscribe(function () {
            _this.netPromoterScoreModalService.open();
        });
    };
    AppComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    AppComponent.prototype.loadIcons = function () {
        var e_1, _a;
        try {
            for (var iconNames_1 = tslib_1.__values(iconNames), iconNames_1_1 = iconNames_1.next(); !iconNames_1_1.done; iconNames_1_1 = iconNames_1.next()) {
                var iconName = iconNames_1_1.value;
                this.matIconRegistry.addSvgIcon(iconName, this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icon/" + iconName + ".svg"));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (iconNames_1_1 && !iconNames_1_1.done && (_a = iconNames_1.return)) _a.call(iconNames_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return AppComponent;
}());
export { AppComponent };
